export default __webpack_public_path__ + "static/media/support-flag-arg.b699023d.svg";